import state from './state'
import mutations from "./mutations";
import actions from './actions'

const
    illegal = {
        namespaced: true,
        state,
        actions,
        mutations
    }
export default illegal